import { useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Typography } from "theme";

import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Dialog, DialogTitle } from "@mui/material";

import { useCancelBooking } from "../../../../api/hooks/useCancelBooking/useCancelBooking.ts";
import { InvertButton } from "../../../../theme/components/Button/Button.tsx";
import ControlledTextField from "../../../ControlledInputs/ControlledTextField.tsx";

import { DeleteFormScheme, deleteSchema } from "./validation.ts";

const CancelBooking = () => {
  const { id } = useParams();
  const [isEditPriceModalOpen, setIsEditPriceModalOpen] = useState(false);

  const cancelBookingProvider = useCancelBooking(id || "");

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<DeleteFormScheme>({
    reValidateMode: "onSubmit",
    resolver: zodResolver(deleteSchema),
    defaultValues: {
      password: ""
    },
  });

  const onSubmit = useCallback(async (data: DeleteFormScheme) => {
    try {
      await cancelBookingProvider.mutateAsync(data);
      reset();
      setIsEditPriceModalOpen(false);
    } catch (e) {
      console.error(e);
    }
  }, [reset]);
  
  return (
    <div>
      <InvertButton type='button' fullWidth  onClick={() => setIsEditPriceModalOpen(true)}>Скасувати</InvertButton>
      <Dialog sx={{
        "& .MuiPaper-root": {
          backgroundColor: "white",
          padding: "16px",
          minWidth: "300px",
        },
      }} open={isEditPriceModalOpen} onClose={() => setIsEditPriceModalOpen(false)}>
        <DialogTitle>Ви впевнені, що хочете скасувати бронювання?</DialogTitle>

        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate my={3.5}>
          <Box mb={2}>
            <ControlledTextField
              control={control}
              required
              name="password"
              label="Код підтвердження"
              placeholder="Введіть код"
              type="text"
            />
            {errors.password?.message &&
              <Typography color="error" variant="body2">{errors.password.message}</Typography>}
          </Box>

          <InvertButton fullWidth type="submit" disabled={isSubmitting} loading={isSubmitting}>
            Скасувати
          </InvertButton>
        </Box>
      </Dialog>
    </div>
  );
};

export default CancelBooking;